import { useEffect, useState, ComponentType } from 'react'

const withRenderClientsideOnly = <P extends object>(
  Component: ComponentType<P>
) => (props: P) => {
  const [show, setShowChildren] = useState(false)

  // delay showing component until after the client side JS loads and hydrates the component
  // works because useEffect will not run in SSR
  useEffect(() => {
    setShowChildren(true)
  }, [])

  if (!show) {
    return null
  }

  return <Component {...props} />
}

export default withRenderClientsideOnly
